import { ca } from '@cian/analytics';
import { IUserGADataLayerData, TUser } from '../../../../common/state';
import { IJsonQuery, ESortValue } from '../../../../json_query';
import { IBreadcrumb, IOffer, offerHelper } from '../../../../offer';
import { normalizeAbGroup } from '../../../../utils/normalizeAbGroup';
import { getExtendedOfferEventExtra, getOfferListingType } from '../../../../utils/offer/tracking';
import { getOfferParentId } from '../../../../utils/trackings';
import { isCommercial, offerTypeFromJsonQuery } from '../../../../utils/category';

export interface ITrackPageJumpOptions {
  jsonQuery: IJsonQuery;
  user?: TUser;
  userGALayerData?: IUserGADataLayerData | null;
  position: number;
  isSimilarFromML?: boolean;
  label: string;
  pageNum?: number;
  breadcrumbs: IBreadcrumb[];
  queryString: string;
  offersQty: number;
}

export const LABEL_WHITE_LIST = ['card_header_in_newlist', 'card_detail_in_newlist', 'card_areas_in_newlist'];
export const trackPageJumped = (offer: IOffer, options: ITrackPageJumpOptions) => {
  const { jsonQuery, breadcrumbs, queryString, pageNum, offersQty, user, userGALayerData, label } = options;
  const { id, variant, ownerId } = offerHelper(offer).getAnalyticsInfo();
  let extra = {};
  const parentId = getOfferParentId(offer, jsonQuery);
  const labelString = LABEL_WHITE_LIST.includes(label) ? label : '';

  if (isCommercial(offerTypeFromJsonQuery(jsonQuery)) && parentId) {
    extra = {
      parentId,
    };
  }

  const ebcObject = {
    name: 'oldevent',
    category: 'Listing',
    action: options.isSimilarFromML ? 'to_card_infinite_search' : 'to_card',
    label: labelString,
    searchConditions: options.jsonQuery,
    modelVersion:
      typeof offer.modelVersion !== 'object' && typeof offer.modelVersion !== 'undefined'
        ? String(offer.modelVersion)
        : undefined,
    products: [
      {
        id,
        offerType: 'offer',
        position: Number(options.position),
        published: offer.status === 'published',
        variant: variant ? variant.split('/') : [],
        ownerId,
        extra,
      },
    ],
    page: {
      listingType: getOfferListingType(offer),
      sortType: jsonQuery.sort ? jsonQuery.sort.value : ESortValue.Default,
      pageNumber: Number(pageNum || 1),
      breadCrumbs: breadcrumbs.map(breadcrumb => breadcrumb.title),
      queryString,
      ...getExtendedOfferEventExtra(offer),
      offersQty,
      pageType: 'Listing',
      siteType: 'desktop',
    },
    user: {
      userId: user && user.isAuthenticated && user.userId ? Number(user.userId) : undefined,
      isAuthorized: Boolean(user && user.isAuthenticated),
      abGroup: normalizeAbGroup(userGALayerData && userGALayerData.abGroup),
    },
  };

  ca('eventEbc', ebcObject);
};
